module.exports = __webpack_public_path__ + "static/media/dark_ru.2163f395.svg";